const development_tenant = {
    notification: 'Вы в режиме разработки',
};
export default Object.freeze(development_tenant);
